import api from "../../utils/api";
import {
  onLoginErr,
  onLogout,
  onLoginLoading,
  onLoginSuccess,
} from "./auth.action";
export const signupAsync =
  ({ name, email, password }) =>
  async (dispatch) => {
    try {
      dispatch(onLoginLoading());
      const response = await api.post("/auth/register", {
        name,
        email,
        password,
        role: "admin",
      });
      let token = response.data.token;
      localStorage.setItem("token", JSON.stringify(token));
      dispatch(getCurrentUserAsync());
      dispatch(onLoginSuccess());
    } catch (e) {
      console.log(e);
      dispatch(
        onLoginErr(
          e.response.data.message ? e.response.data.message : e.message
        )
      );
    }
  };
export const getCurrentUserAsync = () => async (dispatch) => {
  try {
    dispatch(onLoginLoading());
    const { data } = await api.get("/auth/current_user");
    localStorage.setItem("userInfo", JSON.stringify(data.user));
    dispatch(onLoginSuccess());
  } catch (e) {
    console.log(e);
    dispatch(
      onLoginErr(e.response.data.message ? e.response.data.message : e.message)
    );
  }
};

export const loginAsync =
  ({ name, email, password }) =>
  async (dispatch) => {
    try {
      dispatch(onLoginLoading());
      const response = await api.post("/auth/login", {
        name,
        email,
        password,
      });
      let token = response.token;
      localStorage.setItem("token", JSON.stringify(token));
      dispatch(onLoginSuccess());
    } catch (e) {
      console.log(e);
      dispatch(
        onLoginErr(
          e.response.data.message ? e.response.data.message : e.message
        )
      );
    }
  };

export const logoutUserAsync = () => async (dispatch) => {
  try {
    dispatch(onLoginLoading());
    localStorage.clear();
    dispatch(onLogout());
  } catch (e) {
    console.log(e);
    dispatch(
      onLoginErr(e.response.data.message ? e.response.data.message : e.message)
    );
  }
};
